<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="carShow/carShowInfo/getAdvertisementInfo.action"
                    ref="carExhibitionVideoTable">
      <template slot="search">
        <el-row :gutter="10">

          <el-col :span="2">
            <el-button @click="$router.push({path:'/home/carExhibitionVideoDetail',query:{carShowInfoId:queryParams.carShowInfoId }})" type="primary">新增视频</el-button>
          </el-col>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="链接"
            prop="image">
          <template scope="scope">
            <el-row>
              <el-col :span="6" >
                <img :src="baseImageUrl+scope.row.image" style="width:120px;height:120px;margin-left:10px;margin-top: 15px" alt="">
              </el-col>
              <el-col :span="10" style="text-align:left;margin-left:20px;margin-top: 15px">
                <div style="font-size:1.6rem;">{{scope.row.title}}</div>
                <div v-html="scope.row.link" style="color:#999;font-size:1.4rem;margin-top:20pt;word-wrap: break-word;word-break: break-all;overflow: hidden;">
                </div>
              </el-col>

            </el-row>
          </template>
        </el-table-column>

        <el-table-column
            label="操作">
          <template scope="scope">

            <el-button :confirm-data="{id:scope.row.id}"  @onConfirm="$refs.carExhibitionVideoTable.search()"
                       confirm-text="确定删除" requestUrl="/carShow/carShowInfo/deleteAdvertisement.action"
                       type="text"
                       v-confirm>删除
            </el-button>
            <el-button @click="$router.push({path:'/home/carExhibitionVideoDetail', query: { id: scope.row.id }})"
                       type="text">
              修改
            </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'carExhibitionVideo',
  data: function () {
    return {
      baseImageUrl: Config.imageUrl,
      queryParams: {
        type: 2,
        carShowInfoId: null
      }
    }
  },
  methods: {

  },
  activated: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.queryParams.carShowInfoId = carShowInfoId
    this.$refs.carExhibitionVideoTable.search()
  },
  filters: {}
}
</script>

<style scoped>
</style>
